import gql from 'graphql-tag';
import { PLACE_SUBSCRIPTION_ORDER_FRAGMENT } from '../BuyProduct/Step/graphql';

export const APPLY_PARTNER_DISCOUNT_MUTATION = gql`
  ${PLACE_SUBSCRIPTION_ORDER_FRAGMENT}
  mutation applyPartnerDiscountMutation(
    $orderId: ID!
    $partnerId: PartnerId!
    $milanATMInput: PartnerMilanATMInput
  ) {
    applyPartnerDiscount(
      orderId: $orderId
      partnerId: $partnerId
      milanATMInput: $milanATMInput
    ) {
      ... on Order {
        ...PlaceSubscriptionOrder
      }
      ... on PartnerDiscountError {
        errorCode
        message
      }
    }
  }
`;
